import {actionTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export var ReorderingPage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        self.errmsg = '';

        this.topMenu = [
            { title: 'Задачи', url: '/', icon: 'fa-tasks' },
            { title: 'Профиль', url: '/profile', icon: 'fa-user' },
            isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
            { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
        ];

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/reordering'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

        this.orderExtraService = function (serviceId, serviceTitle) {
            self.errmsg = '';

            swal({
                text: `Заказать операцию "${serviceTitle}"?`,
                icon: "success",
                buttons: ["Отмена", "Подтвердить"]
            }).then((value) => {
                if(!value) {
                    return false;
                }

                loader.show();

                var data = {
                    serviceId: parseInt(serviceId)
                };

                m.request({
                    method: 'PUT',
                    url: '/api/task/' + m.route.param('taskId') + '/reordering',
                    data: data
                }).then(function () {
                    server.setOnline();
                    loader.hide();
                    m.route('/task/' + m.route.param('taskId') + '/reordering');
                }, function (response) {

                    data.type = actionTypes.extraOrder;
                    data.taskId = m.route.param('taskId');
                    cache.push(data);

                    if (response && response.message) {
                        self.errmsg = (m(".alert.alert-danger", response.message));
                    } else {
                        server.setOffline();
                    }
                    loader.hide();
                });
            });
        };
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", ''),
            m.component(flightMenuBlock, {
                board: ctrl.data().board,
                menu: ctrl.data().menu,
                tasks: ctrl.data().tasks,
                currentTask: ctrl.data().currentTask,
                tab: 'reordering'
            }),
            ctrl.errmsg,
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th", "Операция"),
                        m("th", "Количество"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    ctrl.data().services.map(function(service) {
                        return [
                            m("tr", [
                                m("td", service.title),
                                m("td", service.amount),
                                m("td", [
                                    m("button.btn.btn-info.btn-block[type='text']", {
                                        onclick: ctrl.orderExtraService.bind(null, service.id, service.title)
                                    }, "Заказать")
                                ])
                            ])
                        ];
                    })
                ])
            ])
        ];
    }
};
